<template>
    <v-card v-if="block[side] && block[side].length" flat tile class="transparent">
        <v-card flat tile class="theme-highlight mb-3"
                v-for="item in block[side]"
                :key="item.UUID"
        >
            <v-card
                v-if="item.action !== 'periodchange'"
                flat
                tile
                class="timelineItem theme-highlight theme-border-inverse"
                :class="getBorder(item)"
                :style="{'pointer-events': (!item.approved && !item.rejectReason) || item.draft ? 'none' : 'all'}"
                @click="changeStatus(item)"
            >
                <TimelineTag :item="item" :rejectReasons="rejectReasons"/>
            </v-card>

            <TimelineDmrActions v-if="item.action !== 'periodchange' && !item.draft && !item.approved && !item.rejectReason" :item="item"/>
            <TimelinePeriod v-if="item.action === 'periodchange'" :item="item"/>
        </v-card>
    </v-card>
</template>

<script>
    import TimelineTag from "@/components/dmr/TimelineTag";
    import TimelinePeriod from "@/components/dmr/TimelinePeriod";
    import TimelineDmrActions from "@/components/dmr/TimelineDmrActions";
    import eventBus from '@/eventBus';
    import CONSTANTS from '@/constants';

    export default {
        name: "TimelineSide",
        components: {
            TimelineTag,
            TimelinePeriod,
            TimelineDmrActions,
        },
        props: {
            side: String,
            block: Object,
            rejectReasons: Object
        },
        methods: {
            changeStatus: function (item) {
                if(item.approved) {
                    eventBus.$emit(CONSTANTS.DMR.REJECT_MODAL, item);
                } else if (item.rejectReason) {
                    eventBus.$emit(CONSTANTS.DMR.APPROVE_MODAL, item);
                }
            },
            getBorder: function (item) {
                if (item.approved) {
                    return 'theme-green-border';
                } else if (item.rejectReason) {
                    return 'theme-red-border';
                }
            },
        }
    }
</script>

<style scoped>
    .timelineItem {
        padding: 8px 10px;
        border-width: 1px;
        border-style: solid;
    }
</style>
